import React from "react";

const BreadcrumbItem = ({ title, url, position, classes, isActive = false, settings = null, isMobile = false }) => {
    // Get font styles from settings if provided
    const fontClass = settings && settings.section ? 
        isMobile ? settings.section.text_style_mobile : settings.section.text_style 
        : "";
    
    return (
        <li
            className={`breadcrumb__item ${fontClass} ${isActive ? "breadcrumb__item--active" : ""} ${classes || ""}`}
            aria-current={isActive ? "page" : undefined}
            itemProp="itemListElement"
            itemScope
            itemType="http://schema.org/ListItem"
        >
            {url ? (
                <a href={url} title={title} itemProp="item" itemScope itemType="http://schema.org/Thing" itemID={url}>
                    <span itemProp="name">{title}</span>
                </a>
            ) : (
                <span itemProp="name">{title}</span>
            )}
            <meta itemProp="position" content={position} />
        </li>
    );
};

export default BreadcrumbItem;
